module.exports = __webpack_public_path__ + "static/media/meubox2.87690eda.png";